import "./index.css";
import "./config/i18n";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import store from "./store/index";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./config/MuiColorThemes";
ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <React.Suspense fallback={<div>Loading</div>}>
          <LocalizationProvider dateAdapter={AdapterDateFns} fullWidth>
            <App />
          </LocalizationProvider>
        </React.Suspense>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>,
  // </React.StrictMode>
  document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
